import * as THREE from 'three';
import { backgroundColor } from './palette';

export function viewportBackground(isDark: boolean): THREE.Color {
  return new THREE.Color(backgroundColor(isDark));
}
